import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation();

    return (
        <footer className="bg-[#1c1c1c] text-white text-sm border-t border-gray-700 mt-4">
            <div className="bg-[#121212] px-4 py-3 border-b border-gray-800">
                <div className="grid grid-cols-2 gap-x-4 gap-y-2 justify-items-center sm:flex sm:justify-center sm:gap-8">
                    <Link to="/feedback" className="hover:underline text-center whitespace-normal sm:whitespace-nowrap">
                        {t("feedback")}
                    </Link>
                    <Link to="/copyright" className="hover:underline text-center whitespace-normal sm:whitespace-nowrap">
                        {t("copyright.title")}
                    </Link>
                    <Link to="/terms" className="hover:underline text-center whitespace-normal sm:whitespace-nowrap">
                        {t("terms.title")}
                    </Link>
                    <Link to="/privacy" className="hover:underline text-center whitespace-normal sm:whitespace-nowrap">
                        {t("privacy.title")}
                    </Link>
                </div>
            </div>

            <div className="pb-4 text-center px-2">
                <div className="mt-2">
                    © {new Date().getFullYear()} {t("copyrightSecuired")}
                </div>
            </div>
        </footer>
    );
}

export default Footer;